/**
 * @file plugins.js
 * @author Geoffrey Pursell
 * @desc load up all the reports plugins we have!
 */

/**
 * @module plugins
 * @desc load up all the reports plugins we have!
 */

define('plugins/all',[
        // libraries
        "underscore",

        // modules
        "cardboard/util",

        // report plugins
        "plugins/highSchoolAcademics","plugins/abeEducationOutcomes", "plugins/collegeActivity", "plugins/stayingInAndCompletingCollege",
        "plugins/developmentalEducation", "plugins/employment", "plugins/newCollegeStudentEnrollment",
        "plugins/newCollegeStudentDemographics", "plugins/collegeGraduates", "plugins/mobility", "plugins/collegeTransfers", "plugins/courseTaking", "plugins/electivesToACTResults", "plugins/rigorousCourseTaking", "plugins/HSGraduatesToEmployment", "plugins/outStateCollegeStudentEnrollment"
    ],
    function (_,
        Util,
        HighSchoolAcademicsPlugin, abeEducationOutcomesPlugin, CollegeActivityPlugin, StayingInAndCompletingCollegePlugin,
        DevelopmentalEducationPlugin, EmploymentPlugin, newCollegeStudentEnrollmentPlugin,
        newCollegeStudentDemographicsPlugin, collegeGraduatesPlugin, mobilityPlugin, collegeTransfersPlugin, courseTakingPlugin, electivesToACTResultsPlugin, rigorousCourseTakingPlugin, HSGraduatesToEmploymentPlugin, outStateCollegeStudentEnrollmentPlugin
    ) {
        console.log("MODULE: plugins");

        var exports = {
            /** plugin registry: this gets built out below. This is used for
             * matching a URL fragment to a plugin request! */
            plugins: {
                highSchoolAcademics: HighSchoolAcademicsPlugin,
                abeEducationOutcomes: abeEducationOutcomesPlugin,
                collegeActivity: CollegeActivityPlugin,
                stayingInAndCompletingCollege: StayingInAndCompletingCollegePlugin,
                developmentalEducation: DevelopmentalEducationPlugin,
                employment: EmploymentPlugin,
                newCollegeStudentEnrollment: newCollegeStudentEnrollmentPlugin,
                newCollegeStudentDemographics: newCollegeStudentDemographicsPlugin,
                collegeGraduates: collegeGraduatesPlugin,
                mobility: mobilityPlugin,
                collegeTransfers: collegeTransfersPlugin,
                courseTaking: courseTakingPlugin,
                electivesToACTResults: electivesToACTResultsPlugin,
                rigorousCourseTaking: rigorousCourseTakingPlugin,
                HSGraduatesToEmployment: HSGraduatesToEmploymentPlugin,
                outStateCollegeStudentEnrollment: outStateCollegeStudentEnrollmentPlugin
            },

            /** add an aliases object to match alternative plugin IDs this gets
             * populated below.
             * @example "alias": "real name" */
            aliases: {}
        };

        // build the hash of plugin aliases
        Util.Plugins.recordAliases(exports);

        return exports;
    });
